export default __webpack_public_path__ + "static/media/avatar_87.39f76752.png";